export enum CustomerTags {
    SPECIAL = "SPECIAL",
    NORMAL = "NORMAL",
    BLACKLISTED = "BLACKLISTED"
  }
  